// src/components/TradeExpiredModal.jsx
import React from 'react';
import { createPortal } from 'react-dom';

function TradeExpiredModal({ isOpen, onClose, tradeId }) {
  if (!isOpen) return null;

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="trade-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
        <div className="trade-modal-header">
          <div className="trade-modal-title">
            <span>خطا در زمان‌بندی</span>
          </div>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="trade-form" style={{ textAlign: 'center', padding: '20px' }}>
          <div style={{ fontSize: '4em', margin: '20px 0', color: '#e74c3c' }}>
            ⏰
          </div>
          
          <h3 style={{ color: '#e74c3c', marginBottom: '15px' }}>
            معامله شما پذیرفته نشد
          </h3>
          
          <p style={{ color: '#7f8c8d', lineHeight: '1.6' }}>
            متاسفانه زمان تایید معامله شما (۸۰ ثانیه) به پایان رسید و مدیر فرصت کافی برای بررسی درخواست شما را نداشت.
          </p>
          
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '10px', 
            borderRadius: '5px', 
            marginTop: '15px',
            border: '1px solid #e9ecef'
          }}>
            <p style={{ margin: 0, color: '#343a40', fontWeight: 'bold' }}>
              شماره معامله: <span style={{ color: '#e74c3c' }}>{tradeId}</span>
            </p>
          </div>

          <button
            className="trade-submit-btn"
            style={{ backgroundColor: '#e74c3c', width: '100%', marginTop: '20px' }}
            onClick={onClose}
          >
            متوجه شدم
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default TradeExpiredModal;
